import React from 'react';
import { IAddressWithCoordinate } from 'Modules/SearchAddress/types';
import styled from 'styled-components';
import Text from 'Components/Typography/Text';
import ScrollbarDropdown from '../ScrollbarDropdown';
import { Flex } from '@igooods/ui-kit';
import { FontSize, FontWeight } from 'theme';
import { colors } from 'constants/colors';
import { useSearchHistoryAddresses } from './utils';
import SearchHistoryList, { StyledHighlightText } from './List';

export const SEARCH_HISTORY_LIST_TEST_ID = 'SEARCH_HISTORY_LIST_TEST_ID';

interface ISearchHistory {
  onSelectHistoryAddress: (address: IAddressWithCoordinate) => void;
  onClearHistory?: () => void;
}

const StyledScrollbarDropdown = styled(ScrollbarDropdown)`
  height: auto;
  ${StyledHighlightText} {
    &:last-child {
      margin-bottom: 30px;
    }
  }
`;

const ClearText = styled(Text).attrs({ color: colors.blackRussian, opacity: 0.4 })`
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`;

const SearchHistory: React.FC<ISearchHistory> = ({ onSelectHistoryAddress, onClearHistory }: ISearchHistory) => {
  const { history, clearHistory } = useSearchHistoryAddresses();

  const handleClearClick = () => {
    clearHistory();
    onClearHistory && onClearHistory();
  };

  if (history.length) {
    return (
      <StyledScrollbarDropdown testId={SEARCH_HISTORY_LIST_TEST_ID}>
        <Flex mb={4} between middle>
          <Text color={colors.blackRussian} fontWeight={FontWeight.semiBold} size={FontSize.s} $nowrap>
            Недавно искали
          </Text>
          <ClearText onClick={handleClearClick}>Очистить</ClearText>
        </Flex>
        <SearchHistoryList list={history} onClick={onSelectHistoryAddress} />
      </StyledScrollbarDropdown>
    );
  }

  return null;
};

export default SearchHistory;
